import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "800px",
	height: "800px",
	viewBox: "-4.32 -4.32 32.64 32.64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_iconCarrier",
			children: /* @__PURE__ */ _jsx("path", { d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" })
		})
	]
});
export default SvgBookmark;
